import {
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody,
    Container,
    Spinner,
    Popover,
    Col,
    Row
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Color } from '../../constants/colors'

export default function SubscriptionDetails({ isOpen, isLoading, subscriptionData, showErrorMessage, target, toggle  }) {
    const RefreshDevices = () => {
        const date = new Date(subscriptionData?.seatChangeDate);
        if (showErrorMessage || !subscriptionData) {
            return (
                <div>
                    Error loading subscription details.
                </div>
            );
        }
        else {
            return (
                <Col>
                    <Row>
                        <b className="mr-1">Current licenses: </b> {subscriptionData.currentSeats}
                    </Row>
                    {subscriptionData.futureSeats &&
                        <Row>
                            <b className="mr-1">Future licenses:</b> {subscriptionData.futureSeats}
                        </Row>
                    }
                    { subscriptionData.seatChangeDate &&
                        <Row>
                            <b className="mr-1">Change date: </b>{date.getMonth() + 1}/{date.getDate()}/{date.getFullYear()}
                        </Row>
                    }
                    {!subscriptionData.seatChangeDate &&
                        <Row>
                            <b className="mr-1">Change date: </b> ASAP (try refreshing page if available devices doesn't match current licenses)
                        </Row>
                    }
                </Col>
            );
        }
    };

    return (
        <Popover
            placement="bottom"
            trigger="focus"
            target={target}
            isOpen={isOpen}
        >
            <PopoverHeader className="d-flex justify-content-between">
                Subscription Details
                <FontAwesomeIcon className="clickable" onClick={toggle} icon={faCircleXmark} size="xs" style={{ color: Color.Red, }} />
            </PopoverHeader>
            <PopoverBody>
                {isLoading &&
                    <Spinner className="centered-loader" />
                }
                {!isLoading &&
                    <Container>
                        <RefreshDevices />
                    </Container>}
            </PopoverBody>

        </Popover>
    )
};